import { Faculty } from "models";
import React from "react";
import { BsFillClockFill, BsFillFileMedicalFill } from "react-icons/bs";
import { FaBriefcase, FaGraduationCap } from "react-icons/fa";
import { GiArchiveResearch } from "react-icons/gi";

import "./SecondaryInfo.scss";

interface FacultySecondaryInfoProps {
  /** The alum whose details should be displayed. */
  facultyMember: Faculty;
  /** Whether the details should be shown in a row or column. */
  direction?: "row" | "column";
}

/** Reusable component to display secondary information for an alum. */
export function FacultySecondaryInfo({
  facultyMember,
  direction,
}: FacultySecondaryInfoProps): JSX.Element {
  return (
    <div className={`secondary-info d-flex flex-${direction || "row"}`}>
      {facultyMember.position && (
        <span className="whitespace">
          <FaGraduationCap className="margin-less" size={23} color="grey" />
          {facultyMember.position}
        </span>
      )}

      {facultyMember.coursesTaught && (
        <span className="whitespace">
          <FaBriefcase className="margin-right" color="grey" />
          Courses Taught: {facultyMember.coursesTaught}
        </span>
      )}

      {facultyMember.researchArea && (
        <span>
          <GiArchiveResearch className="margin-less" color="grey" size={22} />
          Research Area: {facultyMember.researchArea}
        </span>
      )}

      {facultyMember.recentPublications && (
        <span>
          <BsFillFileMedicalFill className="margin-less" color="grey" size={22} />
          Recent Publications: {facultyMember.recentPublications}
        </span>
      )}

      {facultyMember.facultySince && (
        <span className="whitespace">
          <BsFillClockFill className="margin-right" color="grey" />
          Faculty Since {facultyMember.facultySince}
        </span>
      )}
    </div>
  );
}
